import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../store";

const useHttpMaps = (props) => {
  const { link, name } = props;
  const token = useSelector((state) => state.auth.Token);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    fetch(`http://213.233.177.17:8022/${link}`, {
      method: "GET",
      // body: body,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const detail = data.detail;
        if (
          data &&
          (detail === "Invalid Token" ||
            detail === "Access token expired" ||
            detail === "Given token not valid for any token type")
        ) {
          dispatch(logout());
        } else {
          console.log(data);
          setData(data);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  }, [name,dispatch,link,token]);

  return {
    data: data,
    isLoading: isLoading,
  };
};

export default useHttpMaps;
